import BN from 'bignumber.js';

import {
  SET_STAKE_ACTIVE_ASSET,
  SET_STAKE_ACTIVE_TAB,
  SET_STAKE_TOTAL_STAKE_BALANCE_USD,
} from './action-types';
import { OM_STAKING_MIGRATE_STATUS } from '../constants/blockchain-constants';

export const setActiveAsset = (asset) => async (dispatch) => {
  dispatch({ type: SET_STAKE_ACTIVE_ASSET, payload: asset });
};

export const setActiveTab = (tab) => async (dispatch) => {
  dispatch({ type: SET_STAKE_ACTIVE_TAB, payload: tab });
};

export const getTotalStakedBalance = () => (dispatch, getStore) => {
  const {
    UNIV2stake: {
      stake: { stakeBalance: uniV2StakeBalance },
    },
    UNIstake: {
      stake: { stakeBalance: uniStakeBalance },
    },
    RFUELstake: {
      stake: { stakeBalance: rfuelStakeBalance },
    },
    OMV3stake: {
      stake: { stakeBalance: omV3StakeBalance },
    },
    BnbFineStake: {
      stake: { stakeBalance: bnbFineStakeBalance },
    },
    BnbMistStake: {
      stake: { stakeBalance: bnbMistStakeBalance },
    },
    BnbCbdStake: {
      stake: { stakeBalance: bnbCbdStakeBalance },
    },
    BnbBbankStake: {
      stake: { stakeBalance: bnbBbankStakeBalance },
    },
    BnbRosnStake: {
      stake: { stakeBalance: bnbRosnStakeBalance },
    },
    BondlyWbnbStake: {
      stake: { stakeBalance: bondlyWbnbStakeBalance },
    },
    BnbOmStake: {
      stake: { stakeBalance: bnbOmStakeBalance },
    },
    KYLstake: {
      stake: { stakeBalance: kylStakeBalance },
    },
    PKFstake: {
      stake: { stakeBalance: pkfStakeBalance },
    },
    OMV2stake: {
      stake: { stakeBalance: omV2StakeBalance },
    },
    OMstake: {
      stake: { stakeBalance: omStakeBalance, migrateStatus },
    },
    ROYAstake: {
      stake: { stakeBalance: royaStakeBalance },
    },
    FXFstake: {
      stake: { stakeBalance: fxfStakeBalance },
    },
    LABSstake: {
      stake: { stakeBalance: labsStakeBalance },
    },
    L3Pstake: {
      stake: { stakeBalance: l3pStakeBalance },
    },
    ROYAUNIstake: {
      stake: { stakeBalance: uniRoyaStakeBalance },
    },
    RAZEETHUNIstake: {
      stake: { stakeBalance: uniRazeEthStakeBalance },
    },
    BBANKETHUNIstake: {
      stake: { stakeBalance: uniBbankEthStakeBalance },
    },
    BONDLYETHUNIstake: {
      stake: { stakeBalance: uniBondlyEthStakeBalance },
    },
    BCUBEETHUNIstake: {
      stake: { stakeBalance: uniBcubeEthStakeBalance },
    },
    ALPHAETHUNIstake: {
      stake: { stakeBalance: uniAlphaEthStakeBalance },
    },
    BITEETHUNIstake: {
      stake: { stakeBalance: uniBiteEthStakeBalance },
    },
    ZENUSDTOMETHstake: {
      stake: { stakeBalance: zenUsdtOmEthStakeBalance },
    },
    ZENUSDCUNIETHstake: {
      stake: { stakeBalance: zenUsdcUniEthStakeBalance },
    },
    BITEETHINTERVALSstake: {
      stake: { stakeBalance: intervalsBiteEthStakeBalance },
    },
    BONDLYUSDTUNIstake: {
      stake: { stakeBalance: uniBondlyUsdtStakeBalance },
    },
    LABSUNIstake: {
      stake: { stakeBalance: uniLabsStakeBalance },
    },
    LABSUNISIMPLEstake: {
      stake: { stakeBalance: uniLabsSimpleStakeBalance },
    },
    RAZEstake: {
      stake: { stakeBalance: razeStakeBalance },
    },
    SRFUELstake: {
      stake: { stakeBalance: sRfuelStakeBalance },
    },
    BITEstake: {
      stake: { stakeBalance: biteStakeBalance },
    },
    CIRUSstake: {
      stake: { stakeBalance: cirusStakeBalance },
    },
    SKYRIMstake: {
      stake: { stakeBalance: skyrimStakeBalance },
    },
    BCUBEstake: {
      stake: { stakeBalance: bcubeStakeBalance },
    },
    LABSGROUPstake: {
      stake: { stakeBalance: labsGroupStakeBalance },
    },
    ALPHAstake: {
      stake: { stakeBalance: alphaStakeBalance },
    },
    BONDLYETHstake: {
      stake: { stakeBalance: bondlyEthStakeBalance },
    },
    ROSNstake: {
      stake: { stakeBalance: rosnStakeBalance },
    },
    MLTstake: {
      stake: { stakeBalance: mltStakeBalance },
    },
    OMBSCstake: {
      stake: { stakeBalance: omBscStakeBalance },
    },
    OMPOLYGONstake: {
      stake: { stakeBalance: omPolygonStakeBalance },
    },
    GAMERPOLYGONstake: {
      stake: { stakeBalance: gamerPolygonStakeBalance },
    },
    GAMERWETHPOLYGONStake: {
      stake: { stakeBalance: gamerWethPolygonStakeBalance },
    },
    STFIstake: {
      stake: { stakeBalance: stfiStakeBalance },
    },
    STFIWBNBUNIstake: {
      stake: { stakeBalance: stfiWbnbStakeBalance },
    },
    BONDLYBSCstake: {
      stake: { stakeBalance: bondlyBscStakeBalance },
    },
    ZENDAIUNIstake: {
      stake: { stakeBalance: uniZenDaiStakeBalance },
    },
    ZENUSTUNIstake: {
      stake: { stakeBalance: uniZenUstStakeBalance },
    },
    basic: {
      currency: {
        USD: {
          OM: omPrice,
          RFUEL: rfuelPrice,
          ROYA: royaPrice,
          FXF: fxfPrice,
          LABS: labsPrice,
          LABS_GROUP: labsGroupPrice,
          L3P: l3pPrice,
          PKF: pkfPrice,
          BNB_FINE: finePrice,
          BNB_MIST: mistPrice,
          BNB_CBD: cbdPrice,
          BNB_BBANK: bbankPrice,
          RAZE: razePrice,
          BITE: bitePrice,
          CIRUS: cirusPrice,
          SKYRIM: skyrimPrice,
          BCUBE: bcubePrice,
          ALPHA: alphaPrice,
          BONDLY: bondlyPrice,
          ROSN: rosnPrice,
          MLT: mltPrice,
          WBNB: wbnbPrice,
          WETH: wethPrice,
          GAMER: gamerPrice,
          STFI: stfiPrice,
        },
      },
    },
    token: {
      uniV2Price,
      uniPrice,
      labsUniPrice,
      labsUniSimplePrice,
      royaUniPrice,
      razeEthUniPrice,
      bbankEthUniPrice,
      bondlyEthUniPrice,
      bcubeEthUniPrice,
      alphaEthUniPrice,
      biteEthUniPrice,
      zenUsdtOmEthBalance,
      zenUsdcUniEthBalance,
      biteEthIntervalsPrice,
      bondlyUsdtUniPrice,
      kylPrice,
      bnbOmPrice,
      zenDaiUniPrice,
      zenUstUniPrice,
      stfiWbnbPrice,
    },
  } = getStore();

  let totalUsdValue = 0;
  totalUsdValue += omStakeBalance * omPrice;
  if (migrateStatus === OM_STAKING_MIGRATE_STATUS.HIDE_POOL) {
    totalUsdValue += omV2StakeBalance * omPrice;
    totalUsdValue += omV3StakeBalance * omPrice;
  }
  totalUsdValue += bnbFineStakeBalance * finePrice;
  totalUsdValue += bnbMistStakeBalance * mistPrice;
  totalUsdValue += bnbCbdStakeBalance * cbdPrice;
  totalUsdValue += bnbBbankStakeBalance * bbankPrice;
  totalUsdValue += bnbRosnStakeBalance * rosnPrice;
  totalUsdValue += bondlyWbnbStakeBalance * wbnbPrice;

  totalUsdValue += bnbOmStakeBalance * bnbOmPrice;
  totalUsdValue += rfuelStakeBalance * rfuelPrice;
  totalUsdValue += royaStakeBalance * royaPrice;
  totalUsdValue += uniV2StakeBalance * uniV2Price;
  totalUsdValue += uniStakeBalance * uniPrice;
  totalUsdValue += fxfStakeBalance * fxfPrice;
  totalUsdValue += labsStakeBalance * labsPrice;
  totalUsdValue += l3pStakeBalance * l3pPrice;
  totalUsdValue += pkfStakeBalance * pkfPrice;

  totalUsdValue += uniLabsStakeBalance * labsUniPrice;
  totalUsdValue += uniLabsSimpleStakeBalance * labsUniSimplePrice;
  totalUsdValue += uniRoyaStakeBalance * royaUniPrice;

  totalUsdValue += uniRazeEthStakeBalance * razeEthUniPrice;
  totalUsdValue += uniBbankEthStakeBalance * bbankEthUniPrice;
  totalUsdValue += uniBondlyEthStakeBalance * bondlyEthUniPrice;

  totalUsdValue += uniBcubeEthStakeBalance * bcubeEthUniPrice;

  totalUsdValue += uniAlphaEthStakeBalance * alphaEthUniPrice;

  totalUsdValue += uniBiteEthStakeBalance * biteEthUniPrice;

  totalUsdValue += uniZenDaiStakeBalance * zenDaiUniPrice;

  totalUsdValue += uniZenUstStakeBalance * zenUstUniPrice;

  totalUsdValue += zenUsdtOmEthStakeBalance * zenUsdtOmEthBalance;

  totalUsdValue += zenUsdcUniEthStakeBalance * zenUsdcUniEthBalance;

  totalUsdValue += intervalsBiteEthStakeBalance * biteEthIntervalsPrice;

  totalUsdValue += uniBondlyUsdtStakeBalance * bondlyUsdtUniPrice;

  totalUsdValue += kylStakeBalance * kylPrice;
  totalUsdValue += razeStakeBalance * razePrice;

  totalUsdValue += sRfuelStakeBalance * rfuelPrice;

  totalUsdValue += biteStakeBalance * bitePrice;

  totalUsdValue += cirusStakeBalance * cirusPrice;
  totalUsdValue += skyrimStakeBalance * skyrimPrice;

  totalUsdValue += bcubeStakeBalance * bcubePrice;
  totalUsdValue += labsGroupStakeBalance * labsGroupPrice;
  totalUsdValue += alphaStakeBalance * alphaPrice;

  totalUsdValue += bondlyEthStakeBalance * bondlyPrice;

  totalUsdValue += rosnStakeBalance * rosnPrice;

  totalUsdValue += mltStakeBalance * mltPrice;

  totalUsdValue += omBscStakeBalance * omPrice;

  totalUsdValue += omPolygonStakeBalance * omPrice;

  totalUsdValue += gamerWethPolygonStakeBalance * wethPrice;

  totalUsdValue += gamerPolygonStakeBalance * gamerPrice;

  totalUsdValue += stfiStakeBalance * stfiPrice;

  totalUsdValue += stfiWbnbStakeBalance * stfiWbnbPrice;

  totalUsdValue += bondlyBscStakeBalance * bondlyPrice;

  const totalStakedBalance = new BN(totalUsdValue).toFixed(0, BN.ROUND_DOWN);

  dispatch({ type: SET_STAKE_TOTAL_STAKE_BALANCE_USD, payload: totalStakedBalance });

  return totalStakedBalance;
};
